import { render, staticRenderFns } from "./CourseCohortViewStudentsList.vue?vue&type=template&id=1a7ab617&scoped=true&"
import script from "./CourseCohortViewStudentsList.vue?vue&type=script&lang=js&"
export * from "./CourseCohortViewStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./CourseCohortViewStudentsList.vue?vue&type=style&index=0&id=1a7ab617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ab617",
  null
  
)

export default component.exports